export const PALETTE = {
  background: '#0a0a0f',
  backgroundGradEnd: '#13131c',
  gridLine: 'rgba(0, 255, 204, 0.05)',
  cyan: '#00ffcc',
  humanPlayer: '#00ffcc',
  magenta: '#ff0055',
  yellow: '#ffcc00',
  shieldBlue: '#00aaff',
  freezeCyan: '#00ffff',
  white: '#ffffff',
  wallBorder: 'rgba(255, 255, 255, 0.15)',
  wallDuel: 'rgba(255, 255, 255, 0.08)',
  textMuted: '#8b8b9e',
} as const;

export const BOT_COLORS = [
  '#ff0055', // Red / Crimson
  '#ffaa00', // Orange
  '#00ff55', // Lime Green
  '#00aaff', // Sky Blue
  '#aa00ff', // Electric Purple
  '#ff00aa', // Hot Pink
  '#ffff00', // Bright Yellow
] as const;

export const COLOR_NAMES: Record<string, string> = {
  '#ff0055': 'CRIMSON',
  '#ffaa00': 'AMBER',
  '#00ff55': 'VENOM',
  '#00aaff': 'COBALT',
  '#aa00ff': 'VIOLET',
  '#ff00aa': 'MAGENTA',
  '#ffff00': 'GOLD',
  '#00ffcc': 'CYAN'
};

export function getColorName(hex: string): string {
  return COLOR_NAMES[hex.toLowerCase()] || 'ENEMY';
}
